import { Database, get, ref, update } from 'firebase/database';
import { Lesson, Slot } from '@opanuj/shared/types';

export const teachersDelete = async (
    database: Database,
    teacherName: string
): Promise<void> => {
    const [slotsSnapshot, lessonsSnapshot] = await Promise.all([
        get(ref(database, 'slots')),
        get(ref(database, 'lessons')),
    ]);

    const slotsData = slotsSnapshot.val() as Record<string, Slot> | null;
    const lessonsData = lessonsSnapshot.val() as Record<string, Lesson> | null;

    const connectedSlotIds = Object.entries(slotsData ?? {})
        .filter(([, slot]) => slot?.defaultTeacher === teacherName)
        .map(([slotId]) => slotId);

    const connectedLessonIds = Object.entries(lessonsData ?? {})
        .filter(([, lesson]) => lesson?.sourceSlot && connectedSlotIds.includes(lesson.sourceSlot))
        .map(([lessonId]) => lessonId);

    const updates: Record<string, null> = {
        [`teachers/${teacherName}`]: null,
    };

    connectedSlotIds.forEach((slotId) => {
        updates[`slots/${slotId}`] = null;
    });

    connectedLessonIds.forEach((lessonId) => {
        updates[`lessons/${lessonId}`] = null;
    });

    if (Object.keys(updates).length > 0) {
        try {
            await update(ref(database), updates);
        } catch (error) {
            console.error(`Failed to delete teacher "${teacherName}"`, error);
            throw error;
        }
    }
};
